<template>
    <div class="slider"
         :style="data.styleSlider"
         ref="refSlider"
    >
        <!-- The track is made transparent, it is used to position the handler correctly. the middle of the handler should align with the
        head of the track when the value is zero-->
        <div class="slider-track" ref="refTrack">
            <a href="#"
               class="handler"
               ref="refHandler"
               :style="data.styleHandlerInternal"
               :title="props.title"

            >
                <span v-html="data.stepLabel"></span>
            </a>
        </div>

        <!-- Provide a background so that the slider background can fully covers the handler when the slider value reaches min or max.
        This is done by adding the handler width to the slider width-->
        <div class="slider-bg" :style="data.styleBg"  ></div>
        <!-- for increasing touch area for tablet; since the track head and tail will be positioned beyond the slider div for centering the handler,
        an extended hit area with transparent background will be needed so that the touch event can be listened when the handler reaches the head/tail of the slider-->
        <div id="extended-hit-area"
             ref="refBg"
             :style="data.styleExtendedHitArea"
        ></div>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, onUpdated, watchEffect, computed, nextTick}  from "vue"
    import {isTouchDevice, deviceType} from "@/modules/utils/deviceUtils";
    import {isMultiTouch, replaceDefaultTouchBehavior, restoreDefaultTouchBehavior, setBodyPinchZoomOnly} from "@/modules/utils/touchUtils";



    export default {
        props: {
            width:String,
            height:String,
            min:Number,
            max:Number,
            step:Number,
            styleHandler:Object,
            styleBg:Object,
            vertical:Boolean,
            title:String
        },
        setup(props, context) {

            let startX = null;
            let startY = null;
            let initialStartX = null;
            let initialStartY = null;

            const defaultHandlerStyle = {
                background:"#ccc",
                width:"50px",
                height:"25px",
                fontSize:"14px",
                lineHeight:"14px",
                color:"#000",
                background:"#fdd373",
            }

            const defaultBgStyle = {
                width:"100%",
                height:"100%",
                background:"#ccc",
                position:"absolute",
                alignItems:"center",
                boxShadow:"inset 2px 2px 2px #999",
                borderRadius:"10px"
            }

            const handlerWidth = (props.styleHandler === undefined) ? parseInt(defaultHandlerStyle.width) : parseInt(props.styleHandler.width);
            const handlerHeight = (props.styleHandler === undefined) ?  parseInt(defaultHandlerStyle.height) : parseInt(props.styleHandler.height);

            const data = reactive({
                offsetX: -0.5 * handlerWidth,
                offsetY: -0.5 * handlerHeight,
                sliderWidth: 0, //slider client width, used to calculate the slider bg width if horizontal mode,
                sliderHeight: 0, //slider client height, used to calculate the slider bg width if vertical mode
                styleSlider: computed(()=>{

                    if (props.vertical) {
                        return {
                            width:props.styleHandler.width, //props.width,
                            height:props.height //props.height
                        }
                    } else {
                        return {
                            width:props.width, //props.width,
                            height:props.styleHandler.height //props.height
                        }
                    }

                }),
                stepLabel: "",
                currentValue:0,
                styleHandlerInternal: computed(()=>{
                    let obj;

                    if (props.vertical) {
                        obj = {
                            transform: `translate(0, ${data.offsetY}px)`,
                            top: "0",
                            left:"50%",
                            marginLeft: `${-0.5 * handlerWidth}px`,
                        }
                    } else {
                        obj = {
                            transform: `translate(${data.offsetX}px, 0)`,
                            marginTop: `${-0.5 * handlerHeight}px`,
                            top: "50%",
                        }
                    }

                    // obj.pointerEvents = isTouchDevice() ? "none" : "auto";

                    obj.pointerEvents = "auto"

                    if (props.styleHandler === undefined) {
                        return  {
                            ...obj,
                            ...defaultHandlerStyle
                        }
                    } else {
                        return  {
                            ...props.styleHandler,
                            ...obj
                        }
                    }
                }),
                styleExtendedHitArea:computed(()=>{

                    if (props.vertical) {
                        return {
                            width:props.styleHandler.width,
                            height:`${data.sliderHeight }px`,
                            left:"0",
                            top: `${-0.5 * handlerHeight}px`
                        }
                    } else {
                        return {
                            width:`${data.sliderWidth}px`,
                            height:props.styleHandler.height,
                            background:"transparent",
                            position:"absolute",
                            left:`${-0.5 * handlerWidth}px`,
                            top:"0"
                        }
                    }
                })
            })

            const refHandler = ref(null);
            const refSlider = ref(null);
            const refBg = ref(null);
            const refTrack = ref(null);
            const isSliding = ref(false);

            /**
             * This will prevent the default click action for the handler button,
             * This is to avoid the page from scrolling up to top when mouse is released from dragging the handler in vertical mode
             * @param e
             */
            const handlerOnClicked = (e)=>{
                e.preventDefault();
            }


            const handlerOnMouseDown = (e)=>{

                console.log("@slider handlseronmosuedown");
                e.preventDefault();
                console.log("@slider handler on mouse down")
                document.addEventListener("touchmove", handlerOnMouseMove);
                document.addEventListener("touchend", handlerOnMouseUp);
                document.addEventListener("mousemove", handlerOnMouseMove);
                document.addEventListener("mouseup", handlerOnMouseUp);

            }

            const slideTo = (e) => {

                //e.preventDefault();

                if (props.vertical) {

                    //if (isTouchDevice()) {
                    if (isTouchDevice() && e.touches && e.touches.length) {
                        data.offsetY = e.touches[0].pageY - initialStartY - handlerHeight;
                    } else {
                        data.offsetY = e.clientY - startY - handlerHeight;
                    }

                    if (data.offsetY < - handlerHeight * 0.5) {
                        data.offsetY =  -handlerHeight * 0.5;
                    }

                    if (data.offsetY > refSlider.value.clientHeight - handlerHeight * 0.5) {
                        data.offsetY = refSlider.value.clientHeight - handlerWidth * 0.5;
                    }

                } else {

                    //if (isTouchDevice()) {
                    if (isTouchDevice() && e.touches && e.touches.length) {
                        data.offsetX = e.touches[0].pageX - initialStartX - handlerWidth;
                    } else {
                        data.offsetX = e.clientX - startX - handlerWidth;
                    }

                    if (data.offsetX < - handlerWidth * 0.5) {
                        data.offsetX =  -handlerWidth * 0.5;
                    }

                    if (data.offsetX > refSlider.value.clientWidth - handlerWidth * 0.5) {
                        data.offsetX = refSlider.value.clientWidth - handlerWidth * 0.5;
                    }
                }

                context.emit("slider-slide-to", getValue())

            }

            const handlerOnMouseMove = (e)=>{

                console.log("@slider handler on mouse move")
                if (!refSlider.value) {
                    return;
                }

                e.preventDefault();

                if (props.vertical) {

                    //if (isTouchDevice()) {
                    if (isTouchDevice() && e.touches && e.touches.length) {
                        data.offsetY = e.touches[0].pageY - initialStartY - handlerHeight;
                    } else {
                        data.offsetY = e.clientY - startY - handlerHeight;
                    }

                    if (data.offsetY < -handlerHeight * 0.5) {
                        data.offsetY = -handlerHeight * 0.5;
                    }

                    if (data.offsetY > refSlider.value.clientHeight - handlerHeight * 0.5) {
                        data.offsetY = refSlider.value.clientHeight - handlerHeight * 0.5;
                    }

                } else {

                    //if (isTouchDevice()) {
                    if (isTouchDevice() && e.touches && e.touches.length) {
                        data.offsetX = e.touches[0].pageX - initialStartX  - handlerWidth;
                    } else {
                        data.offsetX = e.clientX - startX - handlerWidth;
                    }

                    if (data.offsetX < -handlerWidth * 0.5) {
                        data.offsetX = -handlerWidth * 0.5;
                    }


                    if (data.offsetX > refSlider.value.clientWidth - handlerWidth * 0.5) {
                        data.offsetX = refSlider.value.clientWidth  - handlerWidth * 0.5;
                    }
                }

                isSliding.value = true;

                context.emit("slider-sliding", getValue())

            }

            const handlerOnMouseUp = (e)=>{

                if (!refSlider.value) {
                    return;
                }

                /*
                if (e.cancelable === false) {
                    e.preventDefault();
                }*/

                isSliding.value = false;

                document.removeEventListener("mousemove", handlerOnMouseMove);
                document.removeEventListener("mouseup", handlerOnMouseUp);
                document.removeEventListener("touchmove", handlerOnMouseMove);
                document.removeEventListener("touchend", handlerOnMouseUp);
                context.emit("slider-slided", getValue());
            }

            onMounted(() => {



                nextTick(()=> {
                    if (props.vertical) {

                        startY = refSlider.value.querySelector(".handler").getBoundingClientRect().top;

                        //this makes sure the initial value is assigned once only, that is when the slider is mounted. Since the viewport could have been scaled, so include boy clientLeft also!
                        if (!initialStartY) {
                            initialStartY = refSlider.value.querySelector(".handler").getBoundingClientRect().top - document.querySelector("body").getBoundingClientRect().top
                        }


                        refSlider.value.querySelector(".handler").addEventListener("mousedown", handlerOnMouseDown);
                        refSlider.value.querySelector(".handler").addEventListener("touchstart", handlerOnMouseDown);
                        refBg.value.addEventListener("click", slideTo);
                        refBg.value.addEventListener("touchstart", slideTo);


                        data.sliderHeight = parseInt(refSlider.value.clientHeight) + handlerHeight;
                        data.styleBg = computed(() => {

                            let baseStyle;
                            if (props.styleBg === undefined) {
                                baseStyle = defaultBgStyle;
                            } else {
                                baseStyle = {
                                    ...defaultBgStyle,
                                    ...props.styleBg,
                                }
                            }

                            return {
                                ...baseStyle,
                                width: props.width,
                                height: `${data.sliderHeight}px`,
                                left:"50%",
                                top: `${-0.5 * handlerHeight}px`,
                                marginLeft: `${-0.5 * parseInt(props.width)}px`
                            }
                        })


                        window.addEventListener("resize", (e)=>{
                            if (refSlider.value) {
                                setValue(data.currentValue);
                                data.sliderHeight = parseInt(refSlider.value.clientHeight) + handlerHeight;
                            }
                        })

                        context.emit("slider-ready");

                    } else {

                        startX = refSlider.value.querySelector(".handler").getBoundingClientRect().left;

                        //this makes sure the initial value is assigned once only, that is when the slider is mounted. Since the viewport could have been scaled, so include boy clientLeft also!
                        if (!initialStartX) {
                            initialStartX = refSlider.value.querySelector(".handler").getBoundingClientRect().left - document.querySelector("body").getBoundingClientRect().left
                        }

                        refSlider.value.querySelector(".handler").addEventListener("mousedown", handlerOnMouseDown);
                        refSlider.value.querySelector(".handler").addEventListener("touchstart", handlerOnMouseDown);
                        refBg.value.addEventListener("click", slideTo);
                        refBg.value.addEventListener("touchstart", slideTo);

                        data.sliderWidth = parseInt(refSlider.value.clientWidth) + handlerWidth;
                        data.styleBg = computed(() => {

                            let baseStyle;
                            if (props.styleBg === undefined) {
                                baseStyle = defaultBgStyle;
                            } else {
                                baseStyle = {
                                    ...defaultBgStyle,
                                    ...props.styleBg,
                                }
                            }

                            return {
                                ...baseStyle,
                                width: `${data.sliderWidth}px`,
                                height: props.height,
                                left: `${-0.5 * handlerWidth}px`,
                                top: "50%",
                                marginTop: `${-0.5 * parseInt(props.height)}px`
                            }
                        })


                        window.addEventListener("resize", (e)=>{
                            if (refSlider.value) {
                                setValue(data.currentValue);
                                data.sliderWidth = parseInt(refSlider.value.clientWidth) + handlerWidth;
                            }
                        })

                        context.emit("slider-ready");
                    }

                    window.visualViewport.addEventListener("resize", ()=>{
                        //startX = refSlider.value.querySelector(".handler").getBoundingClientRect().left;
                    });
                });

            })

            const getValue = () => {

                let result;

                if (props.vertical) {

                    if (props.step % 1 === 0) {
                        result = Math.ceil(props.max * (data.offsetY + handlerHeight * 0.5 ) / refSlider.value.clientHeight);
                    } else {
                        result = Math.round(props.max * (data.offsetY + handlerHeight * 0.5)/ refSlider.value.clientHeight * (1 / props.step)) / (1 / props.step);
                    }

                } else {

                    if (props.step % 1 === 0) {
                        result = Math.ceil(props.max * (data.offsetX + handlerWidth * 0.5) / refSlider.value.clientWidth);
                    } else {
                        result = Math.round(props.max * (data.offsetX + handlerWidth * 0.5)  / refSlider.value.clientWidth * (1 / props.step)) / (1 / props.step);
                    }
                }

                if (result <= 0) {
                    result = 0;
                }

                data.currentValue = result;

                return result;
            }

            const setValue = (targetValue) => {

                let isForceAlignHead, isForceAlignTail;

                //if target value is not a multiple of step, e.g. step is 1 but target value is 0.5, and it's smaller than step,  force to align with the head of the slider.
                if (targetValue < props.step) {
                    isForceAlignHead = true;
                }

                //if target value is not a multiple of step, e.g. step is 1 but target value is 0.5, and difference between max and target value is smaller than step force to align with the tail of the slider.
                if (props.max - targetValue < props.step) {
                    isForceAlignTail = true;
                }

                data.currentValue = targetValue;

                if (props.vertical) {
                    if (isForceAlignHead) {
                        data.offsetY = -0.5 * handlerHeight;
                    } else if (isForceAlignTail) {
                        data.offsetY = Math.round(refSlider.value.clientHeight) - handlerHeight * 0.5;
                    } else {
                        data.offsetY = Math.round(refSlider.value.clientHeight / props.max * targetValue) - handlerHeight * 0.5
                    }
                } else {
                    if (isForceAlignHead) {
                        data.offsetX = -0.5 * handlerWidth;
                    } else if (isForceAlignTail) {
                        data.offsetX = Math.round(refSlider.value.clientWidth) - handlerWidth * 0.5;
                    } else {
                        data.offsetX = Math.round(refSlider.value.clientWidth / props.max * targetValue) - handlerWidth * 0.5
                    }
                }

            }

            const setLabel = (label) => {
                data.stepLabel = label;
            }


            return {
                data,
                props,
                refSlider,
                refBg,
                refTrack,
                refHandler,
                isSliding,
                slideTo,
                setLabel,
                getValue,
                setValue,
                handlerOnClicked
            }
        }

    }
</script>

<style scoped lang="scss">

    .slider {
        position: relative;
        user-select:none;
        touch-action: pan-x pan-y;
    }

    .slider-track {
        width:100%;
        height:100%;
        background:transparent;
        position:relative;
        display:flex;
        align-items: center;
    }

    .handler {
        display:flex;
        align-items: center;
        justify-content: center;
        textShadow:"0px 1px 0px rgba(255,255,255,.5)";
        transformOrigin:center center;
        position:absolute;
        text-align:center;
        &:hover {
            @extend .hover-effect !optional;
        }
        padding:0 5px;
        box-sizing:border-box !important; //we dont' want to include the shadow/border etc to calculate the position accurately, so we use border-box for box-sizing
        will-change:transform;

        span {

        }
    }

    #extended-hit-area {
        background:transparent;
        position:absolute;
    }


</style>
